import { memo } from 'react';

import { useMediaQuery } from '@mui/material';
import DetectRTC from 'detectrtc';

import WebinarLobbyWeb from './web/WebinarLobbyWeb';
import WebinarLobbyMobile from './mobile/WebinarLobbyMobile';

import styles from './WebinarLobby.module.scss';

const WebinarLobby = () => {
  const isMobile = useMediaQuery('(max-width:1024px)') || DetectRTC.isMobileDevice;

  return <div className={styles.webinarLobby}>{isMobile ? <WebinarLobbyMobile /> : <WebinarLobbyWeb />}</div>;
};

export default memo(WebinarLobby);
